import React from 'react'
import { Icon, Chip } from '@arnsbogroup/react-voicearchive'
import { Timestamp } from 'components/datatable'
import { useIntl } from 'react-intl'
import messages from './messages'

const FileList = ({refetch, deletable = false, files}) => {
    if (!(!!files.length)) {
      return null
    }

    const { formatMessage } = useIntl()
    const DeleteFile = (file) => {
      if(confirm(formatMessage(messages.confirmDelete, { title: file.title }))) {
        const body = new FormData()
        body.append('fileid', file.uid);
        fetch(`/ordertask/removefile`, { 
          method: 'POST',
          body
        })
        .then((response) => response.text())
        .then(() => {
          refetch()
        })
        .catch((error) => toastr.error(error))
      }
    }

    return (
      <div
        key={files.uid}
        className="overflow-hidden"
      >
        { files.map((file, index) => (
          <>
            { (!files[index - 1] || file.userid != files[index - 1].userid) && file.userid &&
              <div className="border-b bg-gray-50 px-4 py-2 text-xs font-medium">
                {file.userid}
              </div>
            }
            <div className="flex flex-wrap hover:bg-gray-200 border-b">
              <div className="grow px-4 py-2 space-y-2">
                <div className=" flex items-center">
                  <a 
                    href={`/download/task/file/${file.uid}`}
                    className="text-primary-darker hover:text-primary truncate"
                  >
                    { file.title }
                  </a>
                  <Chip className={`ml-2 text-white ${ +file.issource ? 'bg-tertiary border-tertiary' : 'bg-secondary border-secondary' }`}>
                    { +file.issource ? 'Source' : 'Supplier' }
                  </Chip>
                  { file.typeString != 'Audio File' &&
                    <Chip className="ml-2 bg-primary text-white">
                      { file.typeString }
                    </Chip>
                  }
                </div>
                { !!file.comments.length &&
                  <div>
                    { file.comments }
                  </div>
                }
              </div>
                <div className="shrink-0 px-4 py-2 flex items-center space-x-3">
                  { file.typeString == 'Audio File' && 
                    <>
                      <span title="Duration">{ file.duration }</span>
                      <span title="Bit Rate">{ file.bitrate }</span>
                      { !!(+file.samplerate) && 
                        <span title="Sample Rate">{ file.samplerate }kHz</span>
                      }
                    </>
                  }
                  { !!(+file.wordcount) &&
                    <span title="Word count">{ file.wordcount } words</span>
                  }
                  { file.filesize &&
                    <span title="Filesize">{ file.filesize }</span>
                  }
                  <span>
                    <Timestamp>{file.crdate}</Timestamp>
                  </span>
                  { deletable && 
                    <div className="grow text-right">
                      <Icon
                        icon={["fas", "trash"]}
                        state="negative"
                        onClick={() => DeleteFile(file)}
                      />
                    </div>
                  }
              </div>
            </div>
          </>
        ))}
      </div>
    )
  }

export default FileList